import React, { useCallback, useMemo, useState } from 'react';
import BookingModal from 'app/components/Modals/BookingModal';
import { useAppDispatch } from 'store/configureStore';
import { actionHandleShowInfoModal } from 'store/reducers/modal';

import calendlyService from '_services/calendlyService';
import useTenantTranslation from 'utils/hooks/useTenantTranslation';
import BookingContext from './index';

const BookingContextProvider = ({ children }) => {
  const [advisorId, setAdvisorId] = useState<number | null>(null);
  const dispatch = useAppDispatch();
  const { t } = useTenantTranslation();

  const openModal = useCallback(
    async (id: number) => {
      try {
        await calendlyService.checkToken(id);
        setAdvisorId(id);
      } catch (err: any) {
        dispatch(
          actionHandleShowInfoModal({
            closeOnBackgroundClick: true,
            closeButtonText: t('common.back'),
            closeButtonSize: 'large',
            modalTitle: t('common.something_wrong'),
            content:
              err?.response?.data?.message ||
              t('common.alert_messages.generic_error_message'),
            isCloseIconVisible: true,
            classNames: { modalContainer: 'error' },
          }),
        );
      }
    },
    [dispatch],
  );

  const closeModal = useCallback(() => setAdvisorId(null), []);

  const contextValue = useMemo(
    () => ({ openModal, closeModal }),
    [openModal, closeModal],
  );

  return (
    <BookingContext.Provider value={contextValue}>
      {advisorId && <BookingModal advisorId={advisorId} onClose={closeModal} />}
      {children}
    </BookingContext.Provider>
  );
};

export default BookingContextProvider;
